// Hand-written API Gateway client for the netcountable-e2ee service (NC1 key
// layer), following the same factory/makeRequest conventions as the generated
// clients in src/aws/* (see src/aws/survey/apigClient.js for the canonical
// generated shape). SigV4-signed via the shared apiGatewayCore.

import utils from '../apiGatewayCore/utils';
import { apiGatewayClientFactory } from '../apiGatewayCore/apiGatewayClient.js'
import uritemplate from "../apiGatewayCore/url-template"

var apigClientFactory = {};
apigClientFactory.newClient = function (config, invokeUrl) {
    var apigClient = { };
    if(config === undefined) {
        config = {
            accessKey: '',
            secretKey: '',
            sessionToken: '',
            region: '',
            apiKey: undefined,
            defaultContentType: 'application/json',
            defaultAcceptType: 'application/json'
        };
    }
    if(config.accessKey === undefined)  { config.accessKey = ''; }
    if(config.secretKey === undefined)  { config.secretKey = ''; }
    if(config.apiKey === undefined)     { config.apiKey = ''; }
    if(config.sessionToken === undefined) { config.sessionToken = ''; }
    if(config.region === undefined)     { config.region = 'us-east-1'; }
    if(config.defaultContentType === undefined) { config.defaultContentType = 'application/json'; }
    if(config.defaultAcceptType === undefined)  { config.defaultAcceptType = 'application/json'; }

    // extract endpoint and path from url
    var endpoint = /(^https?:\/\/[^\/]+)/g.exec(invokeUrl)[1];
    var pathComponent = invokeUrl.substring(endpoint.length);

    var sigV4ClientConfig = {
        accessKey: config.accessKey,
        secretKey: config.secretKey,
        sessionToken: config.sessionToken,
        serviceName: 'execute-api',
        region: config.region,
        endpoint: endpoint,
        defaultContentType: config.defaultContentType,
        defaultAcceptType: config.defaultAcceptType
    };

    var authType = 'NONE';
    if (sigV4ClientConfig.accessKey !== undefined && sigV4ClientConfig.accessKey !== ''
        && sigV4ClientConfig.secretKey !== undefined && sigV4ClientConfig.secretKey !== '') {
        authType = 'AWS_IAM';
    }

    var simpleHttpClientConfig = {
        endpoint: endpoint,
        defaultContentType: config.defaultContentType,
        defaultAcceptType: config.defaultAcceptType
    };

    var apiGatewayClient = apiGatewayClientFactory.newClient(simpleHttpClientConfig, sigV4ClientConfig);

    // All e2ee routes share the same request shape: query params from the
    // whitelist below, JSON body on writes, optional {pathParam} segments
    // (e.g. /e2ee/enrollments/{requestId}/accept).
    var makeOperation = function (verb, path, queryParamNames, pathParamNames) {
        if(pathParamNames === undefined) { pathParamNames = []; }
        return function (params, body, additionalParams) {
            if(additionalParams === undefined) { additionalParams = {}; }

            utils.assertParametersDefined(params, pathParamNames, ['body']);

            var request = {
                verb: verb.toUpperCase(),
                path: pathComponent + uritemplate(path).expand(utils.parseParametersToObject(params, pathParamNames)),
                headers: utils.parseParametersToObject(params, []),
                queryParams: utils.parseParametersToObject(params, queryParamNames),
                body: body
            };

            return apiGatewayClient.makeRequest(request, authType, additionalParams, config.apiKey);
        };
    };

    // NOTE: deviceUUID is deliberately NOT whitelisted — the browser never
    // sends one, and parseParametersToObject copies every whitelisted key
    // even when absent, which serializes as the literal string
    // "deviceUUID=undefined" and breaks the server's identity lookup.
    var READ_PARAMS = ['email'];
    var WRITE_PARAMS = ['email'];

    apigClient.e2eeAccountGet = makeOperation('get', '/e2ee/account', READ_PARAMS);
    apigClient.e2eeResolveGet = makeOperation('get', '/e2ee/resolve', READ_PARAMS);
    apigClient.e2eeAccountPost = makeOperation('post', '/e2ee/account', WRITE_PARAMS);
    apigClient.e2eeAccountResetPost = makeOperation('post', '/e2ee/account/reset', WRITE_PARAMS);
    apigClient.e2eeIdentityBundleGet = makeOperation('get', '/e2ee/identityBundle', READ_PARAMS);
    apigClient.e2eeIdentityBundlePost = makeOperation('post', '/e2ee/identityBundle', WRITE_PARAMS);
    apigClient.e2eeDeviceListGet = makeOperation('get', '/e2ee/deviceList', READ_PARAMS);
    apigClient.e2eeDeviceListPost = makeOperation('post', '/e2ee/deviceList', WRITE_PARAMS);
    apigClient.e2eeMemberListGet = makeOperation('get', '/e2ee/memberList', READ_PARAMS);
    apigClient.e2eeMemberListPost = makeOperation('post', '/e2ee/memberList', WRITE_PARAMS);
    apigClient.e2eeAdkEnvelopesGet = makeOperation('get', '/e2ee/adkEnvelopes', READ_PARAMS);
    apigClient.e2eeAdkEnvelopesPost = makeOperation('post', '/e2ee/adkEnvelopes', WRITE_PARAMS);
    apigClient.e2eeLogGet = makeOperation('get', '/e2ee/log', ['email', 'from']);
    apigClient.e2eeLogPost = makeOperation('post', '/e2ee/log', WRITE_PARAMS);
    apigClient.e2eeIdentityDeliveryPost = makeOperation('post', '/e2ee/identityDelivery', WRITE_PARAMS);
    apigClient.e2eeRecordsPurgePost = makeOperation('post', '/e2ee/records/purge', WRITE_PARAMS);

    // Device-transfer enrollments. The requester poll and the approver list
    // hit the same GET route but MUST be separate operations: whitelisting
    // deviceUuid on the list call would serialize "deviceUuid=undefined" and
    // flip the server into poll mode (same class of bug as the deviceUUID
    // note above).
    apigClient.e2eeEnrollmentsPost = makeOperation('post', '/e2ee/enrollments', WRITE_PARAMS);
    apigClient.e2eeEnrollmentsListGet = makeOperation('get', '/e2ee/enrollments', READ_PARAMS);
    apigClient.e2eeEnrollmentsPollGet = makeOperation('get', '/e2ee/enrollments', ['email', 'deviceUuid']);
    apigClient.e2eeEnrollmentAcceptPost = makeOperation('post', '/e2ee/enrollments/{requestId}/accept', WRITE_PARAMS, ['requestId']);
    apigClient.e2eeEnrollmentRejectPost = makeOperation('post', '/e2ee/enrollments/{requestId}/reject', WRITE_PARAMS, ['requestId']);

    return apigClient;
};

export default apigClientFactory
